// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const savedUser = localStorage.getItem('user');

        if (token && savedUser) {
            try {
                setUser(JSON.parse(savedUser));
            } catch (error) {
                console.error('Error parsing saved user:', error);
                localStorage.removeItem('token');
                localStorage.removeItem('user');
            }
        }
        setLoading(false);
    }, []);

    const login = async (email, password) => {
        try {
            const response = await authAPI.login(email, password);

            localStorage.setItem('token', response.token);

            const userData = {
                email: response.email || email,
                firstName: response.firstName || null,
                lastName: response.lastName || null,
                gender: response.gender || null,
                role: response.role || 'USER',
                id: response.userId || response.id || null,
            };

            console.log('✅ Login successful, user data saved:', userData);
            localStorage.setItem('user', JSON.stringify(userData));
            setUser(userData);

            return { success: true, user: userData };

        } catch (err) {
            console.error('❌ Login error:', err);

            const responseData = err.response?.data;
            const status = err.response?.status;

            // ✅ Email not verified
            if (status === 403 && responseData?.emailNotVerified) {
                return {
                    success: false,
                    message: responseData.message || 'Вашата email адреса не е потврдена.',
                    emailNotVerified: true
                };
            }

            // ✅ Account locked (rate limiting)
            if (status === 429) {
                return {
                    success: false,
                    message: responseData?.message || 'Сметката е привремено заклучена. Обидете се подоцна.',
                    accountLocked: true
                };
            }

            // ✅ Invalid credentials
            if (status === 401) {
                return {
                    success: false,
                    message: responseData?.message || 'Невалидна email адреса или лозинка.'
                };
            }

            // ✅ Server error
            if (status === 500) {
                return {
                    success: false,
                    message: 'Серверска грешка. Обидете се повторно подоцна.'
                };
            }

            return {
                success: false,
                message: responseData?.message || 'Грешка при најавување.'
            };
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
        console.log('✅ Logged out successfully');
    };

    const isAuthenticated = !!user;

    return (
        <AuthContext.Provider value={{ user, isAuthenticated, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);